// extracted by mini-css-extract-plugin
export default {"meal":"MenuItems_meal__19bxH","description":"MenuItems_description__UoKd9","price":"MenuItems_price__QroXN"};